import { render, staticRenderFns } from "./CostManagement.vue?vue&type=template&id=c56d9bea&"
import script from "./CostManagement.vue?vue&type=script&lang=js&"
export * from "./CostManagement.vue?vue&type=script&lang=js&"
import style0 from "./CostManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports